module.exports = __webpack_public_path__ + "img/fundocard.c14cde61.webp";